import { MibeModel } from './mibemodel.model';

export class NetworkReference implements MibeModel {
  id: number;
  name: string;
  added_by_role: number;

  /**
   * Create a NetworkReference.
   * @param {any} json - The JSON object with which to construct our NetworkReference.
   */
  constructor(json:any) {
    this.loadWithJSON(json);
  }
  /**
   * Load a NetworkReference.
   * @param {any} json - The JSON object with which to load our NetworkReference.
   */
  loadWithJSON(json: any) {
    if (!json) {
      return;
    }
    this.id = json.id;
    this.name = json.name && json.name?.replace(/ {2,}/g, ' ');
    this.added_by_role = json.added_by_role;
  }
  /**
   * Returns a JSON representation of our NetworkReference
   * @return {any} - The JSON representation of our NetworkReference
   */
  toJSON() {
    var json: any = {
      'id': this.id,
      'name': this.name,
      'added_by_role': this.added_by_role
    };
    return json;
  }
}
